import { render, staticRenderFns } from "./ImageChatMessage.htm?vue&type=template&id=7aa01540&scoped=true&"
import script from "./ImageChatMessage.ts?vue&type=script&lang=js&"
export * from "./ImageChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./ImageChatMessage.scss?vue&type=style&index=0&id=7aa01540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa01540",
  null
  
)

export default component.exports